async function addCartproductss(id) {
    const data = { id, quantity: 1 };
    console.log("datadata>",data.id)

    try {
        const response = await fetch('/cart/add.js', {
            method: "POST",
            body: JSON.stringify(data),
            headers: { "Content-Type": "application/json" }
        });

        // console.log("response>>",response)

        const cartData = await response.json();
         window.location.href = "/cart";
        updateMiniCart();

    } catch (error) {
        console.error("Error adding to cart:", error);
    }
}

function updateMiniCart() {
    const $minicart = $('#js_cart_popup');

    $.ajax({
        async: false,
        cache: false,
        url: Shopify.routes.root + 'cart?view=minicart',
        type: 'GET',
        dataType: 'html',
        success: function (response) {
            const cart = $(response).find('#MainContent').length ? $(response).find('#MainContent') : $(response);
            $minicart.html(cart);

            const data = JSON.parse(cart.find('#json-data-cart').text());
            console.log("datadata2",data)
            $(".js-total-price").html(Shopify.formatMoney(data.total_price, theme.moneyFormat))
                .find('.money').css('opacity', '0').delay(500).fadeTo(50, 1);
            $(".js-cart-count").html(data.item_count);
            updateFreeShipping(data);

            document.querySelector('body').dispatchEvent(new Event('contentUpdated'));
        },
        error: function () {
            window.location.reload();
        }
    });
}

$(document).on('click', '.chk-btn-cus', function (event) {

    event.preventDefault();
   event.stopImmediatePropagation();

    const variantId = $(this).attr('var-id'); // Get the variant ID
    $(this).text('Added'); // Update button text

    $(".toast_message_popup")
        .removeClass('slideIn')
        .find('.message')
        .html(`
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="27" viewBox="0 0 28 27" fill="none">
                <path d="M8.64799 20.7238C7.08486 20.7238 5.81776 21.991 5.81776 23.5541C5.81776 25.1172 7.08492 26.3843 8.64799 26.3843C10.2111 26.3843 11.4782 25.1171 11.4782 23.5541C11.4783 21.991 10.2111 20.7238 8.64799 20.7238Z" fill="white"></path>
            </svg> Product Added To Cart
        `)
        .end()
        .addClass('slideIn');

        $('.toast_message_popup').css('display','block');

    setTimeout(() => {
        $(".toast_message_popup").removeClass('slideIn');
        $('.toast_message_popup').css('display','none');
        $(".chk-btn-cus").each(function () {
            if ($(this).text() === 'Added') {
                $(this).html(`
                    <span>
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.73401 3.67367C2.73401 3.40523 2.95162 3.18762 3.22006 3.18762H14.8654C15.5763 3.18762 16.1119 3.83408 15.9798 4.53255L14.8586 10.4587C14.7573 10.9943 14.2893 11.382 13.7443 11.382H4.52137C4.25293 11.382 4.03532 11.1644 4.03532 10.896C4.03532 10.6275 4.25293 10.4099 4.52137 10.4099H13.7443C13.8221 10.4099 13.889 10.3545 13.9035 10.278L15.0246 4.35185C15.0435 4.25207 14.967 4.15972 14.8654 4.15972H3.22006C2.95162 4.15972 2.73401 3.94211 2.73401 3.67367Z" fill="white"></path>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.486048C0 0.217611 0.217611 0 0.486048 0H2.02898C2.57577 0 3.0447 0.39014 3.14417 0.927801L5.35544 12.8806C5.36965 12.9574 5.43664 13.0131 5.51475 13.0131H13.1739C13.4423 13.0131 13.6599 13.2308 13.6599 13.4992C13.6599 13.7676 13.4423 13.9852 13.1739 13.9852H5.51475C4.96797 13.9852 4.49903 13.5951 4.39956 13.0574L2.18829 1.10464C2.17409 1.02783 2.10709 0.972095 2.02898 0.972095H0.486048C0.217611 0.972095 0 0.754484 0 0.486048Z" fill="white"></path>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.75653 15.7156C6.15396 15.7156 6.47614 15.3935 6.47614 14.996C6.47614 14.5986 6.15396 14.2764 5.75653 14.2764C5.3591 14.2764 5.03691 14.5986 5.03691 14.996C5.03691 15.3935 5.3591 15.7156 5.75653 15.7156ZM5.75653 16.6877C6.69083 16.6877 7.44824 15.9303 7.44824 14.996C7.44824 14.0617 6.69083 13.3043 5.75653 13.3043C4.82222 13.3043 4.06482 14.0617 4.06482 14.996C4.06482 15.9303 4.82222 16.6877 5.75653 16.6877Z" fill="white"></path>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0429 15.7156C13.4403 15.7156 13.7625 15.3935 13.7625 14.996C13.7625 14.5986 13.4403 14.2764 13.0429 14.2764C12.6455 14.2764 12.3233 14.5986 12.3233 14.996C12.3233 15.3935 12.6455 15.7156 13.0429 15.7156ZM13.0429 16.6877C13.9772 16.6877 14.7346 15.9303 14.7346 14.996C14.7346 14.0617 13.9772 13.3043 13.0429 13.3043C12.1086 13.3043 11.3512 14.0617 11.3512 14.996C11.3512 15.9303 12.1086 16.6877 13.0429 16.6877Z" fill="white"></path>
                        </svg> Add To Cart
                    </span>
                `);
            }
        });
    }, 3000);

    addCartproductss(variantId); // Call the function with the variant ID
});